import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cellEditFactory from "react-bootstrap-table2-editor";
import { profileColumn } from "Constants/TableColumns";
import { read } from "Helpers/LocalStorage";
import { getAllPriceProductProfile, UpdatePriceProfile, UpdateWeightProfile } from "Stores/actions";
import { Grid } from "@material-ui/core";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import Translator from "Languages/Utility/Translator";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Input from "Components/Input/Input";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';

function ProfileTable() {
  const { t } = useTranslation();
  const {
    priceProfileData,
    selectedTypeColor,
    selectedDasteProfile,
    priceProfileDataPagination,
    rtlLayout
  } = useSelector((state) => ({
    priceProfileData: state.profile.priceProfileData,
    priceProfileDataPagination: state.profile.priceProfileDataPagination,
    selectedTypeColor: state.profile.selectedTypeColor,
    selectedDasteProfile: state.profile.selectedDasteProfile,
    rtlLayout: state.settings.rtlLayout,
  }));
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState(priceProfileData);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [param, setParam] = useState({})
  const [columns, setColumns] = useState();

  useEffect(() => {
    if (selectedDasteProfile) {
      const isAdmin = read("StypeU") === "1";
      const isDasteProfileALU = 
        selectedDasteProfile.Struct 
          ? parseFloat(selectedDasteProfile.Struct) === 2 
            ? false : true : false;
      const isRecordRegisteredByAdmin = selectedDasteProfile.IsG;
      const isUserHasAccessPrice2 = read("addSeriProfileRules").accessPrice2;
      const isUserHasAccessUpdate = read("addSeriProfileRules").accessUpdate;
      const updateProfileColumn = [...profileColumn];
      updateProfileColumn[5].hidden = isAdmin || 
        (isUserHasAccessPrice2 === false && isRecordRegisteredByAdmin);
      updateProfileColumn[5].editable = 
        (isRecordRegisteredByAdmin && isUserHasAccessPrice2) || 
        (!isRecordRegisteredByAdmin && isUserHasAccessUpdate);
      updateProfileColumn[3].hidden = isDasteProfileALU;
      updateProfileColumn[3].editable = (isAdmin && isRecordRegisteredByAdmin) || 
      (!isRecordRegisteredByAdmin && isUserHasAccessUpdate);
      updateProfileColumn[1].align = rtlLayout ? "right" : "left";
      updateProfileColumn[1].headerAlign= rtlLayout ? "right" : "left";
      setColumns(updateProfileColumn);
    }
    return () => setColumns(null);
  }, [selectedDasteProfile]);

  useEffect(() => {
    if (priceProfileData) {
      setTblData(priceProfileData);
      setTotal(priceProfileDataPagination.Total);
      setCurrentPage(priceProfileDataPagination.Page);
      setSizePerPage(priceProfileDataPagination.Limit);
    }
  }, [priceProfileData, priceProfileDataPagination]);

  useEffect(() => {
    (async () => {
      if(selectedTypeColor)
        await onGetPriceAction(false, 1)
    })();
  }, [selectedTypeColor]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      setCurrentPage(page);
      setSizePerPage(sizePerPage);
      await onGetPriceAction(false, page, sizePerPage);
    }
  }

  const setValue = async (name, value) => {
    setSearch(value);
  }

  const onSearch = async (e) => {
    e.preventDefault();
    setCurrentPage(1);
    await onGetPriceAction(false, 1, sizePerPage, search);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    setSearch("");
    setCurrentPage(1);
    await onGetPriceAction(false, 1, sizePerPage, "");
  }

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    setLoading(true);
    newValue = convertToEnglishNumber(newValue) < 0 
      ? (-1 * convertToEnglishNumber(newValue)) 
      : convertToEnglishNumber(newValue);
    if (column.dataField === "GroupPrice" || column.dataField === "UserPrice") {
      const newPrice = isNaN(newValue) ? newValue.replaceAll(",", "") : newValue;
      const oldPrice = oldValue.replaceAll(",", "");
      if (parseFloat(newPrice) !== parseFloat(oldPrice)) {
        try {
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Price: +newPrice,
            IdProduct: row.Id,
          };
          await dispatch(UpdatePriceProfile(data));
          await onGetPriceAction(true);
        } catch (err) {
      console.error('[catch error]', err)
    }
      } else {
        done(false);
      }
    } else if(column.dataField === "Weight") {
      const newWeight = parseFloat(newValue);
      const oldWeight = parseFloat(oldValue);
      if (newWeight !== oldWeight) {
        try {
          const data = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            Weight: newWeight,
            Id: row.Id,
          };
          await dispatch(UpdateWeightProfile(data));
          await onGetPriceAction(true);
        } catch (err) {
      console.error('[catch error]', err)
    }
      } else {
        done(false);
      }
    }
    setLoading(false);
  }

  const onGetPriceAction = async (Force = false, Page = currentPage, Limit = sizePerPage, data = 'NODATA') => {
    setLoading(true);
    try{
      let dataSearch = null;
      if(data !== 'NODATA') {if(data !== '') dataSearch = { Name: convertToEnglishNumber(data) }}
      else if(search !== '') dataSearch = { Name: convertToEnglishNumber(search) }
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdGroupProfile: selectedDasteProfile.Id,
        IdTypeColor: selectedTypeColor.IdTypeColor,
        IdColor: selectedTypeColor.IdColor,
        Limit,
        Page,
        ...dataSearch,
      };
      if(Force || JSON.stringify(params) !== JSON.stringify(param)) {
        // console.log('get', selectedDasteProfile, selectedTypeColor);
        setParam(params);
        await dispatch(getAllPriceProductProfile(params));
      }
    } catch (err) { console.log('[onGetPriceAction]', err) }
    setLoading(false);
  }

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2} className="mb-1">
        <Grid item lg={4} md={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={search}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      {columns && (
        <RemoteTable
          data={tblData}
          keyField="num"
          columns={columns}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          cellEdit={cellEditFactory({
            mode: "click",
            blurToSave: true,
            autoSelectText: true,
            beforeSaveCell: (oldValue, newValue, row, column, done) =>
              BeforeSaveCell(oldValue, newValue, row, column, done),
          })}
          title={<Translator id="list_profile" />}
        />
      )}
    </Fragment>
  );
}

export default ProfileTable;
